import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-100 mt-auto">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">
                51无敌电影网
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200 max-w-md">
              51无敌电影网致力于为广大影视爱好者提供最新电影、电视剧的资讯与在线观看入口。
              覆盖多种类型，便捷查找、智能推荐，让好内容触手可及。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-50 mb-4">
              快速导航
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  搜索影视
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-50 mb-4">
              关于与支持
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/about" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  免责声明
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-200 hover:text-accent-400 transition-colors cursor-pointer">
                  联系方式
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© 2024 51无敌电影网 版权所有 · 本站为影视内容展示演示站，播放功能仅作演示</p>
          <p>
            <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
              隐私政策
            </Link>
            <span className="mx-2">|</span>
            <Link to="/about" className="hover:text-accent-400 transition-colors cursor-pointer">
              用户协议
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}